export default __webpack_public_path__ + "static/media/income_opportunities.24b914c2.png";